import dayjs from 'dayjs';

const toISO = (date) => {
  if (!date) return '-';

  let data = date.toString();
  if (data.includes('`T`'))
    return dayjs(data.replace('`T`', ' ')).format('YYYY.MM.DD HH:mm:ss');
  return dayjs(data).format('YYYY.MM.DD HH:mm:ss');
};

const toHm = (date) => {
  if (!date) return '-';

  let data = date.toString();
  if (data.includes('`T`'))
    return dayjs(data.replace('`T`', ' ')).format('HH:mm');
  return dayjs(data).format('HH:mm');
};

const toYmd = (date) => {
  if (!date) return '-';

  let data = date.toString();
  if (data.includes('`T`'))
    return dayjs(data.replace('`T`', ' ')).format('YYYY.MM.DD');
  return dayjs(data).format('YYYY.MM.DD');
};

export { toISO, toYmd, toHm };
